import * as React from 'react';
import { IgcListComponent as Component } from 'igniteui-webcomponents';
import { createComponent } from '../react-props.js';

/**
 * Displays a collection of data items in a templatable list format.
 * @slot  - Renders the list items and list headers inside default slot.
 * @class
 */
export const IgrList = /* @__PURE__ */ createComponent({
  tagName: 'igc-list',
  displayName: 'IgrList',
  elementClass: Component,
  react: React,
});

export type IgrList = Component;

/** @deprecated Module register is no longer needed and can be removed */
export const IgrListModule = Component;
